define( 'views/fields/preview/element',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-field-input',

		/**
		 * Select the field preview template and initialize runtime-only value state.
		 *
		 * @return {void}
		 */
		initialize: function() {
			
			var type = this.model.get('type');

			// Preview input state is runtime-only. Backfilling it must not make an
			// untouched form look like it has unpublished configuration changes.
			this.model.set('value', this.model.get('default'), { silent: true });
			
			if('date' == type && this.model.get('date_default')){
				var format = this.model.get('date_format');
				if('default' == format || '' == format) format = this.convertDateFormat(nfAdmin.dateFormat);
				var original = moment.locale();
				if( ! moment.locales().includes( 'ninja-forms' ) ) {
					moment.defineLocale('ninja-forms', {
						months: nfi18n.months,
						monthsShort: nfi18n.monthsShort,
						weekdays: nfi18n.weekdays,
						weekdaysShort: nfi18n.weekdaysShort,
						weekdaysMin: nfi18n.weekdaysMin
					} );
				}
				this.model.set('value', moment().format(format), { silent: true } );
				moment.locale(original);
			}

			if('phone' == type) type = 'tel';
			if('spam' == type) type = 'input';
			// if('date' == type) type = 'input';
			if('confirm' == type) type = 'input';
			if('password' == type) type = 'input';
			if('passwordconfirm' == type) type = 'input';
			if('quantity' == type) type = 'number';
			if('terms' == type) type = 'listcheckbox';
			if('liststate' == type) type = 'listselect';
			if('listcountry' == type) type = 'listselect';
			if('listmultiselect' == type) type = 'listselect';
			if('save' == type) type = 'submit';

			// If a builder-specific template exists for this type, use that.
			if ( 1 == jQuery( '#tmpl-nf-builder-field-' + type ).length ) {
				this.template = '#tmpl-nf-builder-field-' + type;
			} else {
				this.template = '#tmpl-nf-field-' + type;
			}			
		},

		onRender: function() {
			// A model can reach render without this setting: any caller that
			// builds a field from a partial row leaves it undefined, and a
			// preview must never take the builder down over a missing class.
			var containerClass = this.model.get('container_class') || '';

			if(containerClass.includes('two-col-list')) {
				jQuery(this.el).find('> ul').css('display', 'grid');
				jQuery(this.el).find('> ul').css('grid-template-columns', 'repeat(2, 1fr)');
			}
			if(containerClass.includes('three-col-list')) {
				jQuery(this.el).find('> ul').css('display', 'grid');
				jQuery(this.el).find('> ul').css('grid-template-columns', 'repeat(3, 1fr)');
			}
			if(containerClass.includes('four-col-list')) {
				jQuery(this.el).find('> ul').css('display', 'grid');
				jQuery(this.el).find('> ul').css('grid-template-columns', 'repeat(4, 1fr)');
			}
		},
        
		templateHelpers: function () {
	    	return {
	    		renderClasses: function() {
	    			// ...
                },
				maybeFilterHTML: function()  {
					return typeof nfAdmin.filter_esc_status !== "undefined" ? nfAdmin.filter_esc_status : "false";
				},
                renderPlaceholder: function() {
                    if('undefined' == typeof this.placeholder) return;
					return 'placeholder="' + String( _.escape( this.placeholder ) ).trim() + '"';
                },
                maybeDisabled: function() {
                    if('undefined' == typeof this.disable_input) return;
                    if(!this.disable_input) return;
                    return 'disabled="disabled"';
                },
                maybeRequired: function() {
					// ...
				},
				maybeInputLimit: function() {
					// ...
				},
				maybeDisableAutocomplete: function() {
					if ( 1 == this.disable_browser_autocomplete ) {
						return 'autocomplete="off"';
					} else if ( this.custom_autocomplete && this.custom_autocomplete.trim() !== '' ) {
						return 'autocomplete="' + this.custom_autocomplete.trim() + '"';
					} else {
						return 'autocomplete="on"';
					}
				},
				maybeChecked: function() {
					if('checked' == this.default_value) return ' checked="checked"';
				},
				renderOptions: function() {
					let optionLabel;
					switch(this.type) {
						case 'terms':

							if( ! this.taxonomy ){
								return '(No taxonomy selected)';
							}

							var taxonomyTerms = fieldTypeData.find(function(typeData){
								return 'terms' == typeData.id;
							}).settingGroups.find(function(settingGroup){
								return 'primary' == settingGroup.id;
							}).settings.find(function(setting){
								return 'taxonomy_terms' == setting.name;
							}).settings;

							var attributes = Object.keys(this);
							var enabledTaxonomyTerms = attributes.filter(function(attribute){
								return 0 == attribute.indexOf('taxonomy_term_') && this[attribute];
							}.bind(this));

							if(0 == enabledTaxonomyTerms.length) {
								return '(No available terms selected)';
							}

							return enabledTaxonomyTerms.reduce(function(html, enabledTaxonomyTerm) {
								var term = taxonomyTerms.find(function(terms){
									return enabledTaxonomyTerm == terms.name;
								});
								if( 'undefined' == typeof term ) return html;
								return html += '<li><input type="checkbox"><div>' + term.label  + '</div></li>';
							}.bind(this), '');
						case 'liststate':
						case 'listselect':

							// Check if there are any options.
							if(0 == this.options.models.length) return '';

							// Filter by :selected" options.
							var options = this.options.models.filter(function(option){
								return option.get('selected');
							});

							// If no option set as "selected", then reset the previous filter.
							if(0 == options.length) options = this.options.models;

							// Set the first option to display in the field preview.
							optionLabel = (typeof nfAdmin.filter_esc_status !== "undefined" && nfAdmin.filter_esc_status === "true") ? _.escape(options[0].get('label')) : options[0].get('label'); 
							return '<option>' + optionLabel + '</option>';
						case 'listmultiselect':
							return this.options.models.reduce(function(html, option) {
								optionLabel = (typeof nfAdmin.filter_esc_status !== "undefined" && nfAdmin.filter_esc_status === "true") ? _.escape(option.get('label')) : option.get('label'); 
								var selected = (option.get('selected')) ? ' selected="selected"' : '';
								return html += '<option' + selected + '>' + optionLabel + '</option>';
							}, '');
						case 'listcheckbox':
							return this.options.models.reduce(function(html, option) {
								optionLabel = (typeof nfAdmin.filter_esc_status !== "undefined" && nfAdmin.filter_esc_status === "true") ? _.escape(option.get('label')) : option.get('label'); 
								var checked = (option.get('selected')) ? ' checked="checked"' : '';
								return html += '<li><input type="checkbox"' + checked + '><div>' + optionLabel + '</div></li>';
							}, '');
						case 'listradio':
							var checked = false; // External flag to only select one radio item.
							return this.options.models.reduce(function(html, option) {
								optionLabel = (typeof nfAdmin.filter_esc_status !== "undefined" && nfAdmin.filter_esc_status === "true") ? _.escape(option.get('label')) : option.get('label'); 
								checked = (option.get('selected') && !checked) ? ' checked="checked"' : '';
								return html += '<li><input type="radio"' + checked + '><div>' + optionLabel   + '</div></li>';
							}, '');
						case 'listcountry':
							var defaultValue = this.default;
							var defaultOption = fieldTypeData.find(function(data) {
								return 'listcountry' == data.id;
							}).settingGroups.find(function(group){
								return 'primary' == group.id;
							}).settings.find(function(setting){
								return 'default' == setting.name;
							}).options.find(function(option) {
								return defaultValue == option.value;
							});
							optionLabel = ('undefined' !== typeof defaultOption ) ? defaultOption.label : '--';
							optionLabel = (typeof nfAdmin.filter_esc_status !== "undefined" && nfAdmin.filter_esc_status === "true") ? _.escape(optionLabel ) : optionLabel; 
							return '<option>' + optionLabel + '</option>';
						default:
							return '';
					}
				},
				renderOtherAttributes: function() {
					var attributes = [];
					if('listmultiselect' == this.type) {
						attributes.push('multiple');

						var multi_size = this.multi_size || '5';
						attributes.push('size="' + multi_size + '"');
					}

					return attributes.join(' ');
				},
				renderProduct: function() {
					// ...
				},
				renderNumberDefault: function() {
					return this.value;
				},
				renderCurrencyFormatting: function() {
					// ...
				},
				renderRatings: function() {
					var ratingOutput = '';
					for (var i = 0; i < this.number_of_stars; i++) {
						ratingOutput += '<i class="fa fa-star" aria-hidden="true"></i>&nbsp;';
					  }
					return ratingOutput;
				},
				renderHourOptions: function() {
            html = '';
            let hours = 12;

            if ( 'undefined' != typeof this.hours_24 && 1 == this.hours_24 ) {
                hours = 24;
            }

            for (var i = 0; i < hours; i++) {
                let value = label = i;

                if ( i < 10 ) {
                    value = label = '0' + i;
                }
                html += '<option value="' + value + '">' + label + '</option>';
                i = i++;
            }

            return html;
        },

        renderMinuteOptions: function() {
            var html = '';
            let minute_increment = 5;

            if ( 'undefined' != typeof this.minute_increment ) {
                minute_increment = this.minute_increment;
            }

            let i = 0;
			
            while( i.toString().length <= 2 && i < 60 ) {
                let value = label = i;

                if ( i < 10 ) {
                    value = label = '0' + i;
                }
                html += '<option value="' + value + '">' + label + '</option>';
                i = i + minute_increment;
            }

            return html;
        },

        maybeRenderAMPM: function() {
            if ( 'undefined' == typeof this.hours_24 || 1 == this.hours_24 ) {
                return;
            }

            return '<div style="float:left;"><select class="ampm" style="float:left;"><option value="am">AM</option><option value="pm">PM</option></select></div>'
        },
        				maybeRenderTime: function() {
					if ( 'time_only' == this.date_mode || 'date_and_time' == this.date_mode ) {
						return true;
					}
					return false;
				},

            }
		},
		
        convertDateFormat: function( dateFormat ) {
            // http://php.net/manual/en/function.date.php
            // https://github.com/dbushell/Pikaday/blob/master/README.md#formatting
            // Note: Be careful not to add overriding replacements. Order is important here.

            /** Day */
            dateFormat = dateFormat.replace( 'D', 'ddd' ); // @todo Ordering issue?
            dateFormat = dateFormat.replace( 'd', 'DD' );
            dateFormat = dateFormat.replace( 'l', 'dddd' );
            dateFormat = dateFormat.replace( 'j', 'D' );
            dateFormat = dateFormat.replace( 'N', '' ); // Not Supported
            dateFormat = dateFormat.replace( 'S', '' ); // Not Supported
            dateFormat = dateFormat.replace( 'w', 'd' );
            dateFormat = dateFormat.replace( 'z', '' ); // Not Supported

            /** Week */
            dateFormat = dateFormat.replace( 'W', 'W' );

            /** Month */
            dateFormat = dateFormat.replace( 'M', 'MMM' ); // "M" before "F" or "m" to avoid overriding.
            dateFormat = dateFormat.replace( 'F', 'MMMM' );
            dateFormat = dateFormat.replace( 'm', 'MM' );
            dateFormat = dateFormat.replace( 'n', 'M' );
            dateFormat = dateFormat.replace( 't', '' );  // Not Supported

            // Year
            dateFormat = dateFormat.replace( 'L', '' ); // Not Supported
            dateFormat = dateFormat.replace( 'o', 'YYYY' );
            dateFormat = dateFormat.replace( 'Y', 'YYYY' );
            dateFormat = dateFormat.replace( 'y', 'YY' );

            // Time - Not supported
            dateFormat = dateFormat.replace( 'a', '' );
            dateFormat = dateFormat.replace( 'A', '' );
            dateFormat = dateFormat.replace( 'B', '' );
            dateFormat = dateFormat.replace( 'g', '' );
            dateFormat = dateFormat.replace( 'G', '' );
            dateFormat = dateFormat.replace( 'h', '' );
            dateFormat = dateFormat.replace( 'H', '' );
            dateFormat = dateFormat.replace( 'i', '' );
            dateFormat = dateFormat.replace( 's', '' );
            dateFormat = dateFormat.replace( 'u', '' );
            dateFormat = dateFormat.replace( 'v', '' );

            // Timezone - Not supported
            dateFormat = dateFormat.replace( 'e', '' );
            dateFormat = dateFormat.replace( 'I', '' );
            dateFormat = dateFormat.replace( 'O', '' );
            dateFormat = dateFormat.replace( 'P', '' );
            dateFormat = dateFormat.replace( 'T', '' );
            dateFormat = dateFormat.replace( 'Z', '' );

            // Full Date/Time - Not Supported
            dateFormat = dateFormat.replace( 'c', '' );
            dateFormat = dateFormat.replace( 'r', '' );
            dateFormat = dateFormat.replace( 'u', '' );

            return dateFormat;
        }

	});

	return view;
} );

